export const portfolioData = {
  name: "Rajat Pandey",
  username: "Blazehue",
  title: "Full-Stack Developer | UI/UX Designer | Creative Coder",
  location: "Chennai, India",
  education: "SRM Institute of Science & Technology - Computer Science & Engineering",
  email: "pandrajat123@gmail.com",
  github: "https://github.com/Blazehue",
  linkedin: "https://www.linkedin.com/in/rajat-pandey-58a949257/",
  instagram: "https://www.instagram.com/zeber356",
  stackoverflow: "https://stackoverflow.com/users/31117881",
  bio: "I'm a developer who's passionate about creating web applications that work well and look good. I spend a lot of time thinking about how code and design can complement each other to create better user experiences. Outside of work, I enjoy creative pursuits like playing guitar, experimenting with 3D modeling in Blender, and learning animation techniques. These hobbies give me a different perspective that sometimes influences how I approach problem-solving in my professional work.",
  philosophy: "Code with purpose, design with passion",
  funFact: "I debug with console.log() and I'm not ashamed 😎",
  
  skills: {
    languages: ["JavaScript", "TypeScript", "Python", "C++", "C"],
    frontend: ["React", "Next.js", "TailwindCSS", "HTML5", "CSS3"],
    backend: ["Node.js", "Express.js", "PostgreSQL", "MongoDB", "Supabase", "Django", "FastAPI"],
    design: ["Figma", "Framer", "Blender", "Adobe Illustrator", "After Effects"],
    tools: ["Git", "GitHub", "VS Code", "Linux", "Vite"],
    learning: ["PostGIS", "Game Physics", "Advanced DSA", "Three.js", "WebGL"]
  },
  
  projects: [
    {
      name: "J.A.R.V.I.S V2",
      description: "A Python-based desktop AI assistant for Windows that manages applications, files, and system settings, responds to voice/text commands, takes screenshots, and provides intelligent, context-aware interactions.",
      tech: ["Python", "AI", "Voice Recognition", "Windows API"],
      github: "https://github.com/Blazehue/J.A.R.V.I.S",
      emoji: "🤖"
    },
    {
      name: "HEZER",
      description: "Browser-based endless space shooter game with third-person pseudo-3D perspective, dynamic star fields, real-time collision detection, and progressive difficulty scaling.",
      tech: ["JavaScript", "LittleJS", "Game Physics"],
      github: "https://github.com/Blazehue/HEZER",
      emoji: "🚀"
    },
    {
      name: "TaskMaster",
      description: "Task-management and productivity web app with local data persistence, due-date filtering, and a responsive interface for organizing daily tasks.",
      tech: ["TypeScript", "React", "Vite", "Local Storage"],
      github: "https://github.com/Blazehue/TaskMaster",
      emoji: "✅"
    },
    {
      name: "XENO",
      description: "Modern interactive quiz platform with timed quizzes, real-time score tracking, and post-quiz performance analysis.",
      tech: ["React", "TypeScript", "Vite", "TailwindCSS"],
      github: "https://github.com/Blazehue/XENO",
      emoji: "🌟"
    },
    {
      name: "Gitnalyzer",
      description: "Intelligent Git repository analytics tool providing detailed insights into commit trends, contributor activity, and repository performance.",
      tech: ["TypeScript", "Git API", "Data Visualization"],
      github: "https://github.com/Blazehue/Gitnalyzer",
      emoji: "📊"
    },
    {
      name: "ParseKIT",
      description: "Web-based JSON↔CSV conversion toolkit with bidirectional conversion, file uploads up to 10 MB, live preview, and real-time validation.",
      tech: ["JavaScript", "HTML5", "CSS3"],
      github: "https://github.com/Blazehue/ParseKIT",
      emoji: "🔧"
    },
    {
      name: "UniVoice",
      description: "University communication hub connecting students and faculty with real-time messaging and collaborative features.",
      tech: ["React", "Node.js", "PostgreSQL", "Socket.io"],
      github: "https://github.com/Blazehue/UniVoice",
      emoji: "🎤"
    },
    {
      name: "Dusk-calc-zen",
      description: "Beautiful calculator with smooth animations and zen design philosophy.",
      tech: ["JavaScript", "CSS3", "HTML5"],
      github: "https://github.com/Blazehue/Dusk-calc-zen",
      emoji: "🌙"
    },
    {
      name: "KNBN",
      description: "Kanban board application for project management and task organization.",
      tech: ["React", "TypeScript", "Drag & Drop"],
      github: "https://github.com/Blazehue/KNBN",
      emoji: "📋"
    }
  ],
  
  resume: "https://github.com/Blazehue",
  
  currentFocus: {
    learning: ["Advanced PostGIS for location-based features", "Game physics & interactive systems", "System design patterns at scale"],
    building: ["Full-stack apps with Supabase", "3D web experiences with Three.js", "Daily DSA problem solving"],
    goals: {
      short_term: "Contribute to major open-source projects",
      long_term: "Build products that impact millions"
    },
    availability: "Open for internships & collaborations! 🚀"
  }
};

export const asciiArt = `
██████╗  █████╗      ██╗ █████╗ ████████╗
██╔══██╗██╔══██╗     ██║██╔══██╗╚══██╔══╝
██████╔╝███████║     ██║███████║   ██║   
██╔══██╗██╔══██║██   ██║██╔══██║   ██║   
██║  ██║██║  ██║╚█████╔╝██║  ██║   ██║   
╚═╝  ╚═╝╚═╝  ╚═╝ ╚════╝ ╚═╝  ╚═╝   ╚═╝   
`;

export const welcomeMessage = [
  "Welcome to Rajat's Terminal Portfolio",
  "Type 'help' to see available commands",
  ""
];